import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { FoundationContextProvider, SurfaceContextProvider, } from '@clds/design-system-foundations';
import { buttonBlenderMapping } from './blenderMapping.js';
import { ButtonContent } from './ButtonContent.js';
import { buttonStyle } from './buttonStyle.js';
import { useFoundation, useLinkSurface } from './foundationMapping.js';
export const LinkButtonRoot = styled.a `
  ${buttonBlenderMapping};
  ${buttonStyle};
  &,
  &:hover {
    text-decoration: none;
  }
`;
// eslint-disable-next-line react/display-name
export const LinkButton = forwardRef(({ size, shape = 'normal', variant, tone, isSelected = false, isDisabled = false, leftSlot, rightSlot, children, tabIndex, ...rest }, ref) => {
    const surface = useLinkSurface({ tone, variant });
    const foundation = useFoundation({ size });
    return (React.createElement(FoundationContextProvider, { ...foundation.innerContextProps },
        React.createElement(SurfaceContextProvider, { ...surface.innerContextProps },
            React.createElement(LinkButtonRoot, { "data-test": "link-button", "aria-disabled": isDisabled, shape: shape, isSelected: isSelected, tabIndex: isDisabled ? -1 : tabIndex, ...surface.componentProps, ...foundation.componentProps, ...rest, ref: ref },
                React.createElement(ButtonContent, { size: foundation.componentProps.size, leftSlot: leftSlot, rightSlot: rightSlot }, children)))));
});
//# sourceMappingURL=LinkButton.js.map